'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import type { ProcessedTheme } from '../ProcessedEntry/DomainEntry/processedTypes'
import { watchClasses } from '../ProcessedEntry/DomainEntry/processedTypes'

// Shared collapsible section chrome — originally lived inside
// CaseEntryDetailPage.tsx, pulled out on its own so other entry-detail pages
// (SibsMailView's SibsEntryDetailPage, RawProcessedEntryPanel) can use it
// too without importing from a page component (which risks a circular
// import the moment that page component wants to render one of those in
// return).
export function CollapsibleSection({
  label,
  theme,
  defaultOpen = false,
  children,
}: {
  label: string
  theme: ProcessedTheme
  defaultOpen?: boolean
  children: React.ReactNode
}) {
  const [open, setOpen] = useState(defaultOpen)
  const c = watchClasses(theme)
  return (
    <section className={`col-span-full flex flex-col overflow-hidden border ${c.line} ${c.panel}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex w-full items-center gap-2 px-4 py-2.5 text-left text-body font-medium transition-colors hover:text-signal ${c.text}`}
      >
        <ChevronDown className={`h-3.5 w-3.5 shrink-0 text-signal transition-transform ${open ? '' : '-rotate-90'}`} />
        {label}
      </button>
      {open && <div className={`border-t p-4 ${c.line}`}>{children}</div>}
    </section>
  )
}
